import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Button, TextField, Card, Typography } from '@material-ui/core';
import LinearProgress from '@material-ui/core/LinearProgress';
import { Formik } from 'formik';
import { string, object } from 'yup';
import { FilePond, registerPlugin } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImageOverlay from 'filepond-plugin-image-overlay';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { addNewsRequest, editNewsRequest } from 'features/AddNews/addNewsSlice';
import { imgBaseURL } from '../../apis/Admin';

registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateType,
  FilePondPluginImageOverlay
);
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  table: {
    minWidth: 1000,
  },
  container: {
    margin: '1rem',
  },
  filter: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '1rem',
  },
  pagination: {
    marginLeft: 'auto',
    marginBottom: '60px',
    margincenter: 'auto',
  },
  cardBackground: {
    padding: '10px',
    border: '1px solid',
  },
  center: {
    textAlign: 'center',
  },
  formStyle: {
    textAlign: 'center',
    margin: 'auto',
    width: '50%',
  },
  start: {
    textAlign: 'start',
  },
  imgReq: {
    paddingLeft: '15px',
    textAlign: 'start',
    color: '#f44336',
    fontSize: '12px',
  },
  paddingTop: {
    paddingTop: '20px',
  },
  buttonSubmit: {
    marginBottom: "20px",
    marginTop: "20px", 
    background: '#45b77c',
    fontFamily: 'sans-serif !important',
    transition: 'background 0.3s ease',
    '&:hover': {
      background: '#358c5e',
    },
  },
  imgWidth: {
    width: '150px',
  },
  heading: {
    color: "#45b77c",
  },
});

const AddNews = ({ currentId, editData, setShowEditImg, showEditBtn }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [files, setFiles] = useState(null);
  const [imgFiles, setImgFiles] = useState(null);
  const [show, setShow] = useState(false);
  const [showImgFile, setShowImgFile] = useState(currentId ? false : true);
  const [showPreBtn, setShowPreBtn] = useState(false);
  const imgUrl = imgBaseURL;
  const [editImgUrl] = useState(`${imgUrl}/${editData.image}`);

  const validationSchema = object().shape({
    title: string().required('Required'),
    description: string().required('Required'),
  });
  const loaderDisplay = useSelector(state => state.addNews.loading);
  const message = useSelector(state => state.addNews.message);

  console.log(files, 'files');

  console.log(imgFiles, 'imgFiles');
  const initialValues = {
    title: currentId ? editData.title : '',
    description: currentId ? editData.description : '',
  };

  console.log(imgFiles, 'img');
  console.log(editData.image, 'editData.image');

  const submitNews = (values, { resetForm }) => {
    if (imgFiles === null) {
      setShow(true);
    } else {
      setShow(false);
    }
    const formData = new FormData();
    if (currentId) {
      formData.append('id', currentId);
    }
    formData.append('title', values.title);
    formData.append('description', values.description);
    if (imgFiles) {
      formData.append('image', imgFiles[0].file);
    } else {
      formData.append('image', editData.image);
    }

    if (files) {
      formData.append('attachment', files[0].file);
    }
    if (currentId) {
      dispatch(editNewsRequest(formData));
    } else {
      dispatch(addNewsRequest(formData));
    }

    resetForm();
    setFiles(null);
    setImgFiles(null);
    setOpen(true);
  };
  console.log(message, 'newsmessage');
  const handleClose = (reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };
  const editImage = () => {
    setShowPreBtn(true);
    setShowEditImg(false);
    setShowImgFile(true);
  };
  const preImage = () => {
    setShowPreBtn(false);
    setShowEditImg(true);
    setShowImgFile(false);
  };
  return (
    <>
      <div className={classes.root}>
        <Grid container spacing={3} className={classes.center}>
          <Grid item xs={12}>
            <Typography variant="h4" component="h4"  className={classes.heading}>
              {currentId ? 'Edit News' : 'Add News'}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Card className={classes.cardBackground}>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={submitNews}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit
                }) => (
                  <form onSubmit={handleSubmit} className={classes.formStyle}>
                    <div className={classes.paddingTop}>
                      <Grid item xs={12} className={classes.paddingTop}>
                        {showImgFile && (
                          <FilePond
                            files={imgFiles}
                            allowReorder={true}
                            allowMultiple={false}
                            acceptedFileTypes={['image/png', 'image/jpeg']}
                            onupdatefiles={setImgFiles}
                            labelIdle='Drag & Drop only images or <span class="filepond--label-action">Browse</span>'
                            credits={false}
                            allowImagePreview={true}
                          />
                        )}
                        {showEditBtn &&
                          currentId &&
                          (imgFiles === null ? (
                            <img
                              src={editImgUrl}
                              alt="editImg"
                              className={classes.imgWidth}
                            />
                          ) : (
                            ''
                          ))}
                        {showEditBtn && (
                          <div className={classes.imgReq}>
                            {show
                              ? imgFiles === null && <span>Required</span>
                              : ''}
                          </div>
                        )}
                      </Grid>
                      <Grid item xs={12}>
                        {showEditBtn && (
                          <Button onClick={editImage}>Edit Image</Button>
                        )}
                      </Grid>
                      <Grid item xs={12}>
                        {showPreBtn && (
                          <Button onClick={preImage}>Previous Image</Button>
                        )}
                      </Grid>
                      <Grid item xs={12} className={classes.paddingTop}>
                        <TextField
                          label="Title"
                          type="text"
                          variant="outlined"
                          name="title"
                          id="formTitle"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.title}
                          helperText={touched.title ? errors.title : false}
                          error={touched.title && !!errors.title}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12} className={classes.paddingTop}>
                        <TextField
                          label="Description"
                          type="text"
                          variant="outlined"
                          name="description"
                          id="formDescription"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.description}
                          helperText={
                            touched.description ? errors.description : false
                          }
                          error={touched.description && !!errors.description}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12} className={classes.paddingTop}>
                        <FilePond
                          files={files}
                          allowReorder={true}
                          allowMultiple={true}
                          acceptedFileTypes={[
                            'text/plain',
                            'application/pdf',
                            'application/doc',
                            'application/rtf',
                            'application/x-iwork-pages-sffpages',
                          ]}
                          onupdatefiles={setFiles}
                          labelIdle='Drag & Drop your files or <span class="filepond--label-action">Browse</span>'
                          credits={false}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.buttonSubmit}
                          onClick={handleSubmit}
                        >
                          {currentId ? 'Update News' : 'Add News'}
                        </Button>
                      </Grid>
                    </div>
                  </form>
                )}
              </Formik>
            </Card>
          </Grid>
        </Grid>
      </div>
      <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity={message === 'Failed' ? 'error' : 'success'}
        >
          <p className="message">{message}</p>
        </Alert>
      </Snackbar>
      {loaderDisplay ? <LinearProgress className="loader" /> : false}
    </>
  );
};

export default AddNews;
